<div class="modal" [class.show]="page"><div class="modal-background" (click)="modal.close()"></div><ng-container #vc=""></ng-container></div>